import { Component } from '@angular/core';

@Component({
  templateUrl: './check-user-R1.component.html',
  styleUrls: ['./check-user-R1.component.scss'],
})
export class CheckUserR1Component {

  constructor() { }

}
